import React, {Component} from 'react';
import {connect} from 'react-redux';
import Typekit from 'react-typekit';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Title from './main/article/title';

class EventFrame extends Component {
	componentWillUpdate() {
		window.scrollTo(0, 0);
	}

	isSingle() {
		return 1 === this.props.posts.length;
	}

	getClasses() {
		return this.isSingle() ? 'content-wrapper fom-pages local-events': 'content-wrapper fom-pages local-events';
	}

	render() {
		return (
			<div>
				<Typekit kitId="eab1tpm" />
				<main className={this.getClasses()}>
					<div className="title-block">
						<div className="row">
							<div className="col"><h1>Local Events</h1></div>
							<div className="col"><h1>County Events</h1></div>
						</div>
					</div>
					<iframe src="https://marshallton.chestercountykiosk.com/marshallton-events" width="540" className="events-iframe local-events"/>
					<iframe src="https://marshallton.chestercountykiosk.com/cc-events-kiosk" width="540" className="events-iframe"/>
				</main>
			</div>
		);
	}
}


function mapStateToProps({posts}) {
	return {posts};
}

export default connect(mapStateToProps)(EventFrame)


// WEBPACK FOOTER //
// ./src/components/event-frame.js